<template>
  <div class="foot_box">
    <Row>
      <Col span="10" offset="6">
        <div style="padding:20px;">
          <p style="font-size: 20px;font-weight: 600;color: #ff7200;">0374-3271036</p>
          <p style="font-size: 16px;">Copyright@2020 Wanli Transport Group All Rights Reserved.</p>
          <br />
          <p style="font-size: 16px;">
            <a href="http://www.miitbeian.gov.cn/"
            target="_blank"
            >豫ICP备17026342号-3</a>&nbsp;&nbsp;
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41102302000160"
              target="_blank"
            >
              <img class="gaba" src="../assets/gaba.png" alt /> 豫公网安备 41102302000160号
            </a>
          </p>
          <p style="font-size: 16px;">地址:河南省许昌市莲城大道与百花北路交叉口万里大厦20层</p>
        </div>
      </Col>
      <Col span="6" style="display:flex;padding-top:20px;">
        <div style="margin-right:30px;">
          <p style="  padding:5px;
                border: 1px solid #ccc;">
            <img src="../assets/157acfe675d362d9a9ed815550f98e5a.png" alt />
          </p>
          <p>万里集团官方微信</p>
        </div>
        <div style="margin-right:30px;">
          <p style="  padding:5px;
                border: 1px solid #ccc;">
            <img src="../assets/1494404870.png" alt />
          </p>
          <p>万里运业官方微信</p>
        </div>
        <div>
          <p style="  padding:5px;
                border: 1px solid #ccc;">
            <img style="width:110px;" src="../assets/20200414153110.jpg" alt />
          </p>
          <p>万里出行官方微信</p>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style scoped>
a {
  color: #575757;
}
.gaba {
  position: relative;
  top: 3px;
  right: -4px;
}
</style>



// WEBPACK FOOTER //
// src/commonality/footer.vue